(() => {
  const root = document.querySelector('[data-editorial]');
  if (!root) return;
  root.querySelector('[data-editorial-share]')?.addEventListener('click', async () => {
    const status = root.querySelector('[data-editorial-share-status]');
    try { await navigator.clipboard.writeText(document.querySelector('link[rel=canonical]')?.href || location.href); status.textContent = 'Link copied'; }
    catch { status.textContent = 'Copy the address from your browser to share this article.'; }
  });
  root.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
    const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
  });
  const body = root.querySelector('[data-editorial-body]');
  const headings = Array.from(body.querySelectorAll('h2'));
  const toc = root.querySelector('[data-editorial-toc]');
  const links = root.querySelector('[data-editorial-toc-links]');
  headings.forEach((heading, i) => {
    if (!heading.id) {
      const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      let id = base, n = 2;
      while (document.getElementById(id)) id = base + '-' + n++;
      heading.id = id;
    }
    const link = document.createElement('a'); link.href = '#' + heading.id; link.textContent = heading.textContent; links.append(link);
  });
  if (headings.length > 1) toc.hidden = false;
  if (headings.length > 2) {
    const target = headings[Math.floor(headings.length / 2)];
    if (target.parentElement === body) target.before(root.querySelector('[data-editorial-mid-offer]').content.cloneNode(true));
  }
  body.querySelectorAll('table').forEach(table => {
    const wrapper = document.createElement('div'); wrapper.className = 'hp-editorial-table-scroll'; wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', table.caption?.textContent || root.dataset.tableLabel);
    table.before(wrapper); wrapper.append(table);
  });
  const sticky = root.querySelector('[data-editorial-sticky]');
  const opening = root.querySelector('.hp-editorial-opening');
  const end = root.querySelector('[data-editorial-end]');
  const update = () => { sticky.hidden = !matchMedia('(max-width: 760px)').matches || opening.getBoundingClientRect().bottom > 0 || end.getBoundingClientRect().top < innerHeight; };
  new IntersectionObserver(update).observe(opening); new IntersectionObserver(update).observe(end);
  addEventListener('scroll', update, {passive:true}); addEventListener('resize',update); update();
  root.addEventListener('click',event => {const cta = event.target.closest('[data-editorial-cta]');if (cta) window.hpTrack?.('article_product_clicked',{placement:cta.dataset.editorialCta,article:location.pathname});});
})();
